import React from "react";
import Footer from "../components/Shared/Footer";
import Breadcrumbs from "../components/Article_Display_Page/Breadcrumbs";
import Navbar from "../components/NavBar/Navbar";
import ShareButton from "../components/Article_Display_Page/ShareButton";
import { Grid, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "../hooks/useTranslation";
import { styled } from "@mui/system";
import Divider from "@mui/material/Divider";
import useGetSiteImage from "../hooks/useGetSiteImage";

const GridContainerMain = styled("div")({
  padding: "0 25% 5px 25%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  "& img": {
    maxWidth: "100%",
    height: "auto",
  },
  "@media (max-width: 1600px)": {
    paddingLeft: "20%",
    paddingRight: "20%",
  },
  "@media (max-width: 960px)": {
    paddingLeft: "10%",
    paddingRight: "10%",
  },
  "@media (max-width: 600px)": {
    paddingLeft: "10%",
    paddingRight: "7%",
  },
});

const LogoImage = styled("img")({
  width: "70px",
  height: "70px",
  marginTop: "10px",
});

const LogoContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
});

const MenuImage = styled("img")(({ theme }) => ({
  width: "100%",
  border: 0,
  boxShadow: theme.shadows[3],
}));

const Menu = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const altLogo = "AltLogo.png";
  const { imageURL, error } = useGetSiteImage(altLogo);
 
  return (
    <div style={{backgroundColor: theme.palette.common.background}}>
      <Navbar />
      <Breadcrumbs title="menu" />
      <Grid container>
        <GridContainerMain>
          <Grid item xs={12} sm={12} md={12}>
            <Typography variant="h1" sx={{ padding: "30px 0 30px 0" }}>
              {t('menu')}
            </Typography>

            <LogoContainer>
              <LogoImage
                src={!error ? imageURL : ""}
                alt="Zielona Chatka Restaurant Logo - Białka Tatrzańska"
                loading="lazy"
              />
              <Typography
                variant="subtitle1"
                sx={{ paddingLeft: "17px", flex: 1, fontSize: ".8rem" }}
              >
                {" "}
                Kotelnica nr II, 34-405 Białka Tatrzańska
              </Typography>
              <ShareButton />
            </LogoContainer>

            <Divider sx={{ padding: "5px" }} />
          </Grid>
        </GridContainerMain>

        <Grid item xs={12}>
          <Grid container
            sx={{
              width: "100%",
              margin: "0 auto",
              display: "flex",
              justifyContent: "center",
              padding: "30px 0px",
            }}
          >
            <Grid item xs={12} sm={12} md={10} lg={7}>
              <MenuImage 
                // src={!error ? imageURL : ""}
                src={`${process.env.REACT_APP_CLIENT_URL}/images/menu1.png`}
                alt="Zielona Chatka Restaurant Menu - Main Courses, Soups, and Traditional Polish Food"
                loading="lazy"
              />
            </Grid>
            
            <Grid item xs={12} sm={12} md={10} lg={7}>
              <MenuImage 
                // src={!error ? imageURL : ""}
                src={`${process.env.REACT_APP_CLIENT_URL}/images/menu2.png`}
                alt="Zielona Chatka Menu Page 2 - Snacks, Fries, Burgers, Kebab, and Desserts"
                loading="lazy"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={10} lg={7}>
              <MenuImage 
                // src={!error ? imageURL : ""}
                src={`${process.env.REACT_APP_CLIENT_URL}/images/menu3.png`}
                alt="Zielona Chatka Drinks Menu - Hot Drinks, Coffee, Cold Beverages, Beer, and Alcoholic Drinks"
                loading="lazy"
              />
            </Grid>

            {/* <Grid item xs={12} sm={12} md={10} lg={7}>
              <img 
                // src={!error ? imageURL : ""}
                src={`${process.env.REACT_APP_CLIENT_URL}/images/menuD.png`}
                alt="Zielon Chatka"
                style={{ width: "100%", border: 0 }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={10} lg={7}>
              <img
                // src={!error ? imageURL : ""}
                src={`${process.env.REACT_APP_CLIENT_URL}/images/menuE.png`}
                alt="Zielon Chatka"
                style={{ width: "50%", border: 0, margin: "0 auto", display: "block" }}
              />
            </Grid> */}

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}
                sx={{
                alignContent: 'center',
                display: 'flex',
                justifyContent: 'center',
                paddingTop: '5%',
                "@media (max-width: 900px)": {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '5%',
                    paddingLeft: '0%',
                },
                }}>
                <Button type="button" href="/order" variant="primaryButton" sx={{height: "4rem", paddingLeft:'3rem', paddingRight:'3rem', marginTop: '3.75rem'}}>
                  {t('orderOnline')}
                </Button>
            </Grid>
          </Grid>
        </Grid>

      </Grid>
      <Footer />
    </div>
  );
};

export default Menu;